import { Action } from '@ngrx/store';
import { Bdil } from '../models/bd-il.model';

export enum BdilActionTypes {
  BDIL_QUERY = '[Bdil] Query',
  BDIL_LOADED = '[Bdil] Fetched',

  BDIL_ADDED = '[Bdil] Added',
  BDIL_EDITED = '[Bdil] Edited',
  BDIL_DELETED = '[Bdil] Deleted',
  BDIL_SAVED = '[Bdil] Saved',

  BDIL_ERROR = '[Bdil] Error'
}

export class BdilQuery implements Action {
  readonly type = BdilActionTypes.BDIL_QUERY;
}

export class BdilLoaded implements Action {
  readonly type = BdilActionTypes.BDIL_LOADED;

  constructor(public payload: { bdils: Bdil[] }) {}
}

export class BdilAdded implements Action {
  readonly type = BdilActionTypes.BDIL_ADDED;

  constructor(public payload: { bdil: Bdil }) {}
}

export class BdilEdited implements Action {
  readonly type = BdilActionTypes.BDIL_EDITED;

  constructor(public payload: { bdil: Bdil }) {}
}

export class BdilSaved implements Action {
  readonly type = BdilActionTypes.BDIL_SAVED;

  constructor(public payload: {bdil: Bdil}) {}
}

export class BdilDeleted implements Action {
  readonly type = BdilActionTypes.BDIL_DELETED;

  constructor(public payload: { bdil: Bdil }) {}
}

export class BdilError implements Action {
  readonly type = BdilActionTypes.BDIL_ERROR;

  constructor(public payload: { error: any }) {}
}

export type BdilActions =
  | BdilQuery
  | BdilLoaded
  | BdilAdded
  | BdilEdited
  | BdilSaved
  | BdilDeleted
  | BdilError;
